<template>
    <section class="content">
        <div class="form-group">
            <FormInput :value="value" @input="s => $emit('input', s)"
                       type="select" :options="industryList" class="w-1/2"/>
            <ErrorText name="industry" :errors="errors"/>
        </div>
    </section>
</template>

<script>
import SectionLabel from "./SectionLabel";
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";
import applicationSelectItem from "../../mixins/applicationSelectItem";

export default {
    name: "IndustryForm",
    components: {ErrorText, FormInput, SectionLabel},
    mixins: [applicationSelectItem],

    props: {
        value: {
            type: String,
        },
        errors: {
            type: Object | Array,
        }
    },
}
</script>

<style scoped>

</style>
